// extracted by mini-css-extract-plugin
export default {"choices":"lsf-choices","choices_hidden":"lsf-choices_hidden","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630378345
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  